<template>
  <router-link v-if="to && !disabled" :to="to" :class="cssClass" @click="click">
    <slot></slot>
  </router-link>
  <a
    v-else-if="href && !disabled"
    :href="href"
    :download="download"
    :target="target"
    :class="cssClass"
    @click="click"
  >
    <slot></slot>
  </a>
  <button
    v-else
    :type="type"
    :class="cssClass"
    :disabled="disabled"
    @click="click"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    block: {
      type: Boolean,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false
    },
    download: {
      type: String,
      required: false
    },
    href: {
      type: String,
      required: false
    },
    size: {
      type: String,
      required: false
    },
    target: {
      type: String,
      required: false
    },
    type: {
      type: String,
      required: false,
      default: 'button'
    },
    to: {
      type: Object,
      required: false
    },
    variant: {
      type: String,
      required: false
    }
  },
  computed: {
    cssClass() {
      return {
        'c-btn': true,
        'c-btn--block': this.block,
        ['c-btn--' + this.size]: this.size,
        ['c-btn--' + this.variant]: this.variant
      };
    }
  },
  methods: {
    click(e) {
      this.$emit('click', e);
    }
  }
};
</script>
